const Companies = () => {
  return (
    <div className="flex my-4 gap-8 py-8 flex-wrap justify-center sm:flex-col">
      <img src="/assets/brands/fa-brands-1.svg" />
      <img src="/assets/brands/Vector.svg" />
      <img src="/assets/brands/col-md-2.svg" />
      <img src="/assets/brands/col-md-3.svg" />
      <img src="/assets/brands/aws.svg" />
      <img src="/assets/brands/reddit.svg" />
    </div>
  );
};

export default Companies;
